// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-results-ShowMore-styles__root","info":"src-components-results-ShowMore-styles__info","button":"src-components-results-ShowMore-styles__button"};